/* SwaySeat attribution and capture.
   Built by scripts/build-capture.py. Do not edit in the theme editor: the next
   run of that script overwrites this file. */
(function () {
  /* Loaded site-wide from layout/theme.liquid AND by the capture sections, so
     guard against running twice: a second run would register a second submit
     listener and subscribe every signup twice. */
  if (window.__ssAttributionLoaded) { return; }
  window.__ssAttributionLoaded = true;

  var FIRST = 'ss_first_touch';
  var LAST = 'ss_last_touch';
  var PUBLIC_ID = 'Ts5egs';
  var LIST_ID = 'VJRTTD';
  var REVISION = '2026-07-15';

  function store() {
    try {
      var t = window.localStorage;
      t.setItem('__t', '1');
      t.removeItem('__t');
      return t;
    } catch (e) {
      return null;  /* private browsing, or storage disabled */
    }
  }

  /* Classify a referrer when the link carried no UTM parameters, which is most
     organic traffic. Deliberately coarse: source buckets that can actually be
     acted on, rather than a long tail of hostnames nobody will read. */
  function classify(ref) {
    if (!ref) return { source: 'direct', medium: 'none' };
    var host = '';
    try { host = new URL(ref).hostname.replace(/^www\./, ''); } catch (e) {}
    if (!host || host.indexOf(location.hostname) !== -1) {
      return { source: 'direct', medium: 'none' };
    }
    var search = /google\.|bing\.|duckduckgo\.|yahoo\.|ecosia\./;
    var social = /facebook\.|instagram\.|reddit\.|youtube\.|linkedin\.|tiktok\.|pinterest\.|x\.com|twitter\./;
    if (search.test(host)) return { source: host, medium: 'organic' };
    if (social.test(host)) return { source: host, medium: 'social' };
    return { source: host, medium: 'referral' };
  }

  function touch() {
    var p = new URLSearchParams(location.search);
    var guess = classify(document.referrer);
    return {
      source: p.get('utm_source') || guess.source,
      medium: p.get('utm_medium') || guess.medium,
      campaign: p.get('utm_campaign') || '',
      content: p.get('utm_content') || '',
      term: p.get('utm_term') || '',
      referrer: document.referrer || '',
      landing_page: location.pathname + location.search,
      at: new Date().toISOString()
    };
  }

  var s = store();
  var current = touch();

  /* First touch is written once and then left alone forever. That is the whole
     point: it survives every later visit, so a customer who found them through
     a forum in March and bought in July is still credited to the forum. */
  if (s && !s.getItem(FIRST)) {
    try { s.setItem(FIRST, JSON.stringify(current)); } catch (e) {}
  }
  if (s) {
    try { s.setItem(LAST, JSON.stringify(current)); } catch (e) {}
  }

  function read(key, fallback) {
    if (!s) return fallback;
    try { return JSON.parse(s.getItem(key)) || fallback; }
    catch (e) { return fallback; }
  }

  function attribution() {
    var f = read(FIRST, current);
    var l = read(LAST, current);
    return {
      first_touch_source: f.source,
      first_touch_medium: f.medium,
      first_touch_campaign: f.campaign,
      first_touch_landing_page: f.landing_page,
      first_touch_referrer: f.referrer,
      first_touch_at: f.at,
      last_touch_source: l.source,
      last_touch_medium: l.medium,
      last_touch_campaign: l.campaign
    };
  }

  window.ssAttribution = attribution;

  /* Push the same values onto the Shopify cart so they ride through checkout
     and land on the order, under the order's "Additional details".

     Rewritten 2026-09-14 after a real test order arrived with no attribution.
     The first version stamped once per browsing session and set its "done"
     flag without checking the response. On the password page the cart cannot
     be reached, the update failed silently, the flag was set anyway, and no
     later page ever tried again. It would also have skipped a second order in
     the same session, since Shopify starts a fresh cart after checkout.

     Now: ask the cart whether it already carries attribution, and stamp only
     if it does not. That is once per cart rather than once per session, so it
     heals itself on every page until it has worked. Skipped on the password
     page, where the cart is unreachable. Failure must never block a purchase,
     so errors are swallowed. */
  function stampCart() {
    if (location.pathname.indexOf('/password') === 0) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var have = cart.attributes || {};
        if (have.first_touch_source) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attribution() })
        });
      })
      .catch(function () {});
  }
  stampCart();

  /* ---- capture form ---- */

  /* Bot filtering, added 2026-09-15. An audit of the Email List found five
     signups from one bot: a scripted browser submitting dotted Gmail
     addresses (Gmail ignores the dots, so the mail reaches a real person who
     never signed up) from Tor and other anonymising networks. Every one
     submitted 1.3 to 1.7 seconds after the page loaded; the fastest real
     person took 23.5 seconds. Its user agent also arrived wrapped in literal
     quote marks, which no real browser sends. Four got through and were sent
     welcome emails, which ends in spam complaints against the sending domain.

     Four checks, in order of certainty:
     1. navigator.webdriver: set by browser automation, never by a person.
     2. A user agent starting with a quote mark: the signature of this bot.
     3. A hidden trap field: invisible to people and skipped by the keyboard,
        but form-filling bots fill every field they find.
     4. Submitting under 3 seconds after page load. This one is not silent: a
        person who really is that fast (autofill and a quick click) is asked
        to press the button again, so no real signup is ever lost to it.
     The first three show the normal success message and send nothing, so
     the bot has no signal to adapt to. */
  var LOADED_AT = Date.now();
  var MIN_MS = 3000;
  var TRAP = 'ss_hp';

  function addTrap(form) {
    if (form.querySelector('input[name=' + TRAP + ']')) return;
    var wrap = document.createElement('div');
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText =
      'position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;';
    wrap.innerHTML =
      '<label>Leave this field empty <input type="text" name="' + TRAP +
      '" tabindex="-1" autocomplete="off" value=""></label>';
    form.appendChild(wrap);
  }
  Array.prototype.forEach.call(
    document.querySelectorAll('form[data-ss-capture]'), addTrap);

  function looksAutomated(form) {
    if (navigator.webdriver) return true;
    var ua = navigator.userAgent || '';
    if (ua.charAt(0) === '"' || ua.charAt(0) === "'") return true;
    var trap = form.querySelector('input[name=' + TRAP + ']');
    return !!(trap && trap.value);
  }

  function showDone(form) {
    /* The list is SINGLE opt-in, so this really is done: the profile is
       created on receipt and no confirmation email is involved. If it is
       ever switched back to double opt-in, this copy becomes a lie and
       must change to tell people to check their inbox. See
       scripts/klaviyo-optin.py. */
    form.innerHTML =
      '<p class="ss-cap-done">You are on the list. We will email you ' +
      'when pre-orders open.</p>';
  }

  function subscribe(email, form) {
    var status = form.querySelector('[data-ss-status]');
    var button = form.querySelector('button');

    /* Segment pages declare who they were written for. Recording it on the
       profile is the whole point of running several of them: it turns "which
       language converts for which rider" into something queryable rather than
       something argued about. Falls back to 'general' on the home page. */
    var props = attribution();
    props.signup_segment = form.getAttribute('data-ss-segment') || 'general';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, properties: props }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: LIST_ID } } }
      }
    };

    if (button) { button.disabled = true; }
    if (status) { status.textContent = 'One moment'; status.className = 'ss-cap-status'; }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + PUBLIC_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (button) { button.disabled = false; }
      if (r.ok || r.status === 202) {
        showDone(form);
      } else if (status) {
        status.textContent = 'That did not go through. Try again in a moment.';
        status.className = 'ss-cap-status ss-cap-error';
      }
    }).catch(function () {
      if (button) { button.disabled = false; }
      if (status) {
        status.textContent = 'That did not go through. Try again in a moment.';
        status.className = 'ss-cap-status ss-cap-error';
      }
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-ss-capture')) {
      return;
    }
    event.preventDefault();
    var field = form.querySelector('input[type=email]');
    if (!field || !field.value || field.value.indexOf('@') === -1) { return; }
    if (looksAutomated(form)) { showDone(form); return; }
    if (Date.now() - LOADED_AT < MIN_MS && !form.hasAttribute('data-ss-again')) {
      form.setAttribute('data-ss-again', '');
      var status = form.querySelector('[data-ss-status]');
      if (status) {
        status.textContent = 'Press the button once more to confirm.';
        status.className = 'ss-cap-status';
      }
      return;
    }
    subscribe(field.value.trim(), form);
  });
})();
